import { CloseNetworkOutlineIcon } from './CloseNetworkOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 6BB0D686-C2A2-47D0-A50C-91E0300AF12E
 * name close-network-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/close-network-outline.svg
 * tags
 */
export const MultiplyNetworkOutlineIcon = CloseNetworkOutlineIcon;
export default MultiplyNetworkOutlineIcon